import { Button } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import TextField from "@material-ui/core/TextField";
import ConfirmButton, {
  ConfirmButtonTransitionState
} from "@saleor/components/ConfirmButton";
import ControlledCheckbox from "@saleor/components/ControlledCheckbox";
import Form from "@saleor/components/Form";
import FormSpacer from "@saleor/components/FormSpacer";
import { CountryDetailsFragment_regions } from "@saleor/fragments/types/CountryDetailsFragment";
import { CountryErrorFragment } from "@saleor/fragments/types/CountryErrorFragment";
import useModalDialogErrors from "@saleor/hooks/useModalDialogErrors";
import { buttonMessages } from "@saleor/intl";
import { maybe } from "@saleor/misc";
import { getFormErrors } from "@saleor/utils/errors";
import getCountryErrorMessage from "@saleor/utils/errors/country";
import React, { Dispatch, SetStateAction } from "react";
import { FormattedMessage, useIntl } from "react-intl";

export interface RegionEditDialogFormData {
  name: string;
  code: string;
  displayOrder: number;
  reenable: boolean;
}
export interface RegionsEditDialogProps {
  errors: CountryErrorFragment[];
  regions: CountryDetailsFragment_regions | null;
  confirmButtonState: ConfirmButtonTransitionState;
  disabled: boolean;
  open: boolean;
  onClose: () => void;
  onSubmit: (data: RegionEditDialogFormData) => void;
  textChange: Dispatch<SetStateAction<boolean>>;
}
const RegionEditDialog: React.FC<RegionsEditDialogProps> = ({
  regions,
  confirmButtonState,
  disabled,
  errors: apiErrors,
  onClose,
  onSubmit,
  open,
  textChange
}) => {
  const intl = useIntl();
  const errors = useModalDialogErrors(apiErrors, open);
  const formErrors = getFormErrors(["code", "name"], errors);
  const initialForm: RegionEditDialogFormData = {
    name: maybe(() => regions.name, ""),
    code: maybe(() => regions.code, ""),
    displayOrder: maybe(() => regions.displayOrder, 999),
    reenable: maybe(() => regions.enable, true)
  };

  return (
    <Dialog onClose={onClose} open={open} fullWidth maxWidth="sm">
      <DialogTitle>
        {regions === null ? (
          <FormattedMessage
            defaultMessage="Add Region"
            description="add Regions"
          />
        ) : (
          <FormattedMessage
            defaultMessage="Edit Regions"
            description="edit Region"
          />
        )}
      </DialogTitle>
      <Form initial={initialForm} onSubmit={onSubmit}>
        {({ change, data, submit }) => (
          <>
            <DialogContent>
              <TextField
                autoFocus
                disabled={disabled}
                fullWidth
                name={"name" as keyof RegionEditDialogFormData}
                label={intl.formatMessage({
                  defaultMessage: "Name",
                  description: "Name"
                })}
                value={data.name}
                onChange={event => {
                  change(event);
                  textChange(true);
                }}
                error={!!formErrors.name}
                helperText={getCountryErrorMessage(formErrors.name, intl)}
              />
              <FormSpacer />
              <TextField
                autoFocus
                disabled={disabled}
                fullWidth
                name={"code" as keyof RegionEditDialogFormData}
                label={intl.formatMessage({
                  defaultMessage: "Code",
                  description: "Code"
                })}
                value={data.code}
                onChange={change}
                error={!!formErrors.code}
                helperText={getCountryErrorMessage(formErrors.code, intl)}
              />
              <FormSpacer />

              <FormSpacer />
              <TextField
                autoFocus
                disabled={disabled}
                fullWidth
                name={"displayOrder" as keyof RegionEditDialogFormData}
                label={intl.formatMessage({
                  defaultMessage: "DisplayOrder",
                  description: "DisplayOrder"
                })}
                value={data.displayOrder}
                onChange={change}
              />
              <FormSpacer />
              <ControlledCheckbox
                name={"reenable" as keyof RegionEditDialogFormData}
                label={intl.formatMessage({
                  defaultMessage: "isEnable",
                  description: "enable"
                })}
                checked={data.reenable}
                onChange={event => {
                  change(event);
                  // eslint-disable-next-line no-console
                 // console.log(event.target);
                }}
                disabled={disabled}
              />
              <FormSpacer />
            </DialogContent>
            <DialogActions>
              <Button onClick={onClose}>
                <FormattedMessage {...buttonMessages.back} />
              </Button>
              <ConfirmButton
                transitionState={confirmButtonState}
                color="primary"
                variant="contained"
                // onClick={(event)=>{
                //     // submit
                //     // eslint-disable-next-line no-console
                //     console.log(data)
                //     }
                // }
                onClick={submit}
              >
                <FormattedMessage {...buttonMessages.save} />
              </ConfirmButton>
            </DialogActions>
          </>
        )}
      </Form>
    </Dialog>
  );
};
export default RegionEditDialog;
